import SmallBadge from "@/common/components/SmallBadge";
import { cn } from "@/common/utils/cn";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { FilePlusIcon } from "lucide-react";
import { useCallback, useId, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData } from "../../../types/updatedSummary.type";
import CreateAuctionProposal from "./CreateAuctionProposal";

interface CreateAuctionProposalButtonProps {
  auctionEntryId: string | undefined;
  auctionSummary: MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData | undefined;
  disabled?: boolean;
}

const CreateAuctionProposalButton = ({
  auctionEntryId,
  auctionSummary,
  disabled = false,
}: CreateAuctionProposalButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const tooltipId = useId();

  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (disabled || !auctionSummary?.directive_entry_type) {
      return;
    }

    if (auctionSummary?.directive_entry_type === MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry) {
      return navigate(`/maintenance-establishment-choice/auction-entries/${auctionEntryId}/create-execution-proposal`);
    }

    setIsOpen(true);
  }, [disabled, auctionSummary?.directive_entry_type, auctionEntryId]);

  return (
    <>
      <SmallBadge
        data-tooltip-id={disabled ? tooltipId : undefined}
        LeftIcon={FilePlusIcon}
        text="Nova proposta"
        className={cn(
          'bg-primary-blue hover:bg-primary-blue-hover transition-colors cursor-pointer',
          disabled && 'opacity-50 cursor-not-allowed hover:bg-primary-blue',
        )}
        onClick={handleClick}
      />

      {disabled && (
        <Tooltip id={tooltipId} style={{ zIndex: 50 }}>
          Não é possível enviar proposta em leilão pausado
        </Tooltip>
      )}

      <CreateAuctionProposal
        auctionEntryId={auctionEntryId}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  );
}

export default CreateAuctionProposalButton;
